import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { Eye } from "lucide-react";
import SEO from "@/components/SEO";
import ShareButtons from "@/components/site/ShareButtons";

export default function Blog() {
    const { t, lang } = useI18n();
    const [items, setItems] = useState([]);
    // Fetch blog posts on component mount
    useEffect(() => { api.get("/blogs").then((r) => setItems(r.data)); }, []);
    return (
        <div>
            <SEO title={t("blog_title")} />
            {/* Hero / Page Header */}
            <section className="bg-hero-grad py-10 sm:py-14">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-xs font-bold tracking-wider text-brand-red">INSIGHTS</div>
                    <h1 className="text-3xl sm:text-5xl font-bold text-brand-navy mt-2 leading-tight">{t("blog_title")}</h1>
                </div>
            </section>
            {/* Blog Grid */}
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {items.map((b) => (
                        <div key={b.id} className="bg-white border border-brand-light rounded-2xl overflow-hidden hover:shadow-soft hover:-translate-y-1 transition group">
                            <Link to={`/blog/${b.id}`}>
                                {/* Cover Image */}
                                <div className="aspect-video overflow-hidden bg-brand-light/40">
                                    <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover" />
                                </div>
                                {/* Card Body */}
                                <div className="p-5 pb-3">
                                    <div className="text-[10px] tracking-wider font-bold text-brand-red uppercase">{b.category}</div>
                                    <h3 className="font-bold text-brand-navy mt-2 line-clamp-2">{b.title}</h3>
                                    <div className="text-sm text-brand-navy/65 mt-2 line-clamp-2">{b.excerpt}</div>
                                    {/* Author & Views */}
                                    <div className="flex items-center gap-3 mt-4 text-xs text-brand-navy/55">
                                        <span className="font-medium">{b.author}</span>
                                        <span className="inline-flex items-center gap-1"><Eye className="w-3 h-3" /> {b.views || 0}</span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
